<template>
  <div class="filter-search-result">
    <div class="filter-title-search-result">
      <span v-if="selectedFilters.length">
        Filter ({{ selectedFilters.length }})
      </span>
      <SFilterChip
        :chipName="filter.label"
        :chipIcon="filter.icon"
        :chipId="filter.value"
        @removeChip="$emit('removeFilter', filter)"
        v-for="filter in selectedFilters"
        :key="filter.label"
      />
      <SButtonMaterial
        v-if="showClearButton"
        class="clear-filter-button"
        :md-ripple="false"
        buttonType="button"
        textColor="danger"
        color="transparent"
        materialClass="dense"
        text="Clear all"
        @button="$emit('clearFilter')"
        data-cy="clear-filter-btn"
      />
    </div>

    <div class="filter-selects">
      <!-- Category -->
      <!-- <div class="filter-select item-activity" v-if="isItemActivity">
        <SSelectMaterial
          :options="options[0]"
          v-model="choice.optionsPost"
          data-cy="filterBar"
          :selectLabel="selectLabel"
          ref="options"
          dropDownClass="category"
          :multiple="true"
          @md-selected="$emit('postSearch', choice)"
        />
        <SSelectMaterial
          v-if="!showMyPosts"
          :options="options[1]"
          v-model="choice.optionsRequest"
          data-cy="filterBar"
          :selectLabel="selectLabel"
          ref="options"
          dropDownClass="category"
          :multiple="true"
          @md-selected="$emit('requestSearch', choice)"
        />
      </div> -->

      <!-- Type -->
      <!-- <div class="filter-select" v-else>
        <SSelectMaterial
          :options="options"
          v-model="choice.options"
          data-cy="filterBar"
          :selectLabel="selectLabel"
          ref="options"
          :multiple="true"
          dropDownClass="searchType"
          @md-selected="$emit('button', choice)"
        />
      </div> -->

      <!-- Category - All  -->
      <div class="filter-select" v-if="searchType === 'search-bar'">
        <SSelectMaterial
          :options="optionsCategory"
          v-model="choice.itemCategory"
          data-cy="filterBarItemCategory"
          selectLabel="Category - All"
          selectFor="category"
          ref="category"
          :multiple="true"
          dropDownClass="searchItemCategory"
          @md-selected="$emit('categoryButton', choice)"
        />
      </div>

      <!-- Condition -->
      <div class="filter-select">
        <SSelectMaterial
          :options="optionsCondition"
          v-model="choice.itemCondition"
          data-cy="filterBarItemCondition"
          selectLabel="Item condition - All"
          selectFor="condition"
          class="select-component-condition"
          :multiple="true"
          dropDownClass="searchItemCondition"
          @md-selected="$emit('button', choice)"
        />
      </div>

      <!-- Trade Type -->
      <div class="filter-select">
        <SSelectMaterial
          :options="optionsType"
          v-model="choice.itemType"
          data-cy="filterBarItemType"
          selectLabel="Trade type - All"
          selectFor="trade"
          :multiple="true"
          dropDownClass="searchItemTrade"
          @md-selected="$emit('button', choice)"
        />
      </div>

      <!-- Sort by -->
      <div class="filter-select">
        <SSelectMaterial
          :options="optionsSort"
          v-model="choice.itemSort"
          data-cy="filterBarItemSort"
          selectLabel="Sort By"
          selectFor="sort"
          class="select-component-sort"
          dropDownClass="searchItemSort"
          @md-selected="$emit('sortby', choice)"
        />
      </div>

      <!-- Privacy Type -->
      <!-- <div class="filter-select">
        <SSelectMaterial
          :options="optionsPrivacy"
          v-model="choice.privacy"
          data-cy="filterBarGroupType"
          selectLabel="Privacy type - All"
          selectFor="privacy"
          :multiple="true"
          :dropDownClass= getDropdownBothSelected()
          @md-selected="$emit('button', choice)"
        />
      </div> -->
    </div>

  </div>
</template>

<script>
import SSelectMaterial from "@/material-components/molecules/SSelectMaterial.vue";
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import SFilterChip from "@/material-components/molecules/SFilterChip.vue";
export default {
  name: "SFilterBar",
  props: {
    options: Array,
    choice: Object,
    optionsType: Array,
    optionsPrivacy: Array,
    startWith: Array,
    startCategory: Array,
    optionsCategory: Array,
    optionsCondition: Array,
    optionsSort: Array,
    selectedFilters: Array,
    outsideLabel: String,
    selectName: String,
    isItemActivity: Boolean,
    showMyPosts: Boolean,
    searchType: String
  },
  components: {
    SSelectMaterial,
    SButtonMaterial,
    SFilterChip,
  },
  model: {
    prop: "input",
    event: "change",
  },
  methods: {
    destroy() {
      this.$destroy();
    },
    setNewItemOptions(category) {
      this.choice.options = [""];
      this.choice.itemCategory = [category];
      this.choice.options = ["item"];
      setTimeout(() => {
        this.$refs.options.update();
        this.$refs.category.update();
      }, 300);
    },
    getDropdownBothSelected() {
      if(this.choice.options.includes('item')) {
        return "searchGroupPrivacyBoth";
      }
      return "searchGroupPrivacy";
    },
  },
  computed: {
    showClearButton() {
      return this.choice.itemCategory.length !== 0 ||
        this.choice.itemCondition.length !== 0 ||
        this.choice.itemType.length !== 0 ||
        this.choice.itemSort.length !== 0
    },
    selectLabel() {
      return this.selectName ? this.selectName : "Type - All";
    },
    label() {
      return this.outsideLabel ? this.outsideLabel : "Type";
    },
  },
  watch: {
    startWith(option) {
      if (option) {
        this.choice.options = option;
        if (this.startCategory >= 1 && this.startCategory <= 12) {
          this.choice.itemCategory = this.startCategory;
        }
        this.$emit("button", this.choice);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-search-result {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.filter-title-search-result {
  width: 100%;
  padding: 15px 0px;

  display: flex;
  justify-content: start;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;

  span {
    font-size: 12px;
    color: $black;
    line-height: 20px;
    letter-spacing: 1.25px;
  }
}

.filter-selects {
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
}

.filter-select {
  width: 100%;
}

.filter-title {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  font-weight: bold;
}
.ui-filter-title {
  font-weight: bold;
  text-align: left;
  width: 15.5%;
}
.ui-block-title {
  border: 0;
  display: flex;
  align-items: center;
}
.bootstrap-select > .dropdown-toggle {
  margin-bottom: 0 !important;
}
.clear-filter-button {
  text-transform: unset;
  font-weight: 400;
  font-size: 13px !important;
  margin-left: unset;
}

.ui-block-title {
  padding-left: unset;
  padding-top: unset;
}

.select-component-sort {
}

@media screen and (min-width: 400px) {
  .filter-select {
    flex-direction: row;
    align-items: space-between;
    gap: 10px;
  }
}

@media screen and (min-width: 768px) {
  .filter-selects {
    flex-direction: row;
    gap: 10px;
  }
}

@media screen and (min-width: 1024px) {
  .filter-select {
    max-width: 180px;
  }
}
</style>
